import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from "@mui/material"
import React from "react"
import { LoadingButton } from "../LoadingButton/LoadingButton"
import { useStyles } from "./styles"

export interface AlertModalProps extends DialogProps {
    confirmText?: string
    danger?: boolean // makes confirm button red
    declineText?: string
    onClose: () => void
    onConfirm?: React.MouseEventHandler<HTMLButtonElement>
    open: boolean
    pending?: boolean
    title: string
}

export const AlertModal = ({
    children,
    confirmText,
    danger = false,
    declineText = "Back",
    title,
    onClose,
    onConfirm,
    open,
    pending,
}: AlertModalProps) => {
    const { classes, cx } = useStyles()

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            {children && <DialogContent>{children}</DialogContent>}
            <DialogActions>
                {declineText && (
                    <Button variant="outlined" onClick={onClose}>
                        {declineText}
                    </Button>
                )}
                {onConfirm && (
                    <LoadingButton
                        pending={pending}
                        color="primary"
                        className={cx({ [classes.btn_delete]: danger })}
                        variant="outlined"
                        onClick={onConfirm}
                    >
                        {confirmText ?? "Confirm"}
                    </LoadingButton>
                )}
            </DialogActions>
        </Dialog>
    )
}
